import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';

interface ReportStudent {
  child_id: number;
  studentFirstName: string;
  studentLastName: string;
  displayName: string;
  class: string;
  fatherFirstName: string;
  fatherLastName: string;
  fatherDisplayName: string;
  motherFirstName: string;
  motherLastName: string;
  motherDisplayName: string;
}

@Component({
  selector: 'app-students-dialog',
  templateUrl: './students-dialog.component.html',
  styleUrls: ['./students-dialog.component.scss']
})
export class StudentsDialogComponent implements OnInit {
  students: MatTableDataSource<ReportStudent>;
  isLoading: boolean;
  mode: number;
  uniqueId: string;
  displayColumns = ['displayName', 'school', 'className', 'fatherDisplayName', 'motherDisplayName'];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private commonService: CommonService,
              public toastMessagesService: ToastMessagesService,
              public dialogRef: MatDialogRef<StudentsDialogComponent>) {
    this.isLoading = true;
    this.mode = +data.mode;
    this.uniqueId = data.unique_id;
    this.students = new MatTableDataSource<ReportStudent>(data.info);
    this.isLoading = false;
  }

  async ngOnInit() {
    // console.log(this.mode);
    // await this.initStudents();
  }

  async initStudents() {
    try {
      if (this.mode === 0) {
        const studentsQuery = await this.commonService.getList(`reports/consent/children?uniqueId=${this.uniqueId}`);
        for (const student of studentsQuery.object as ReportStudent[]) {
          student.displayName = `${student.studentFirstName} ${student.studentLastName}`;
          student.fatherDisplayName = student.fatherFirstName ?  `${student.fatherFirstName} ${student.fatherLastName}` : '-';
          student.motherDisplayName = student.motherFirstName ? `${student.motherFirstName} ${student.motherLastName}` : '-';
        }
        this.students = new MatTableDataSource<ReportStudent>(studentsQuery.object);
      } else  if (this.mode === 1) {
        const studentsQuery = await this.commonService.getList(`reports/affirmation/children?uniqueId=${this.uniqueId}`);
        for (const student of studentsQuery.object as ReportStudent[]) {
          student.displayName = `${student.studentFirstName} ${student.studentLastName}`;
          student.fatherDisplayName = student.fatherFirstName ?  `${student.fatherFirstName} ${student.fatherLastName}` : '-';
          student.motherDisplayName = student.motherFirstName ? `${student.motherFirstName} ${student.motherLastName}` : '-';
        }
        this.students = new MatTableDataSource<ReportStudent>(studentsQuery.object);
      } else {
        const studentsQuery = await this.commonService.getList(`reports/announcement/children?uniqueId=${this.uniqueId}`);
        for (const student of studentsQuery.object) {
          student.displayName = `${student.childFirstName} ${student.childLastName}`;
          student.fatherDisplayName = student.parentFirstName && student.father_id === student.parent_id ?  `${student.parentFirstName} ${student.parentLastName}` : '-';
          student.motherDisplayName = student.parentFirstName && student.mother_id === student.parent_id  ?  `${student.parentFirstName} ${student.parentLastName}` : '-';
        }
        this.students = new MatTableDataSource<ReportStudent>(studentsQuery.object);
      }
      this.isLoading = true;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  close() {
    this.dialogRef.close();
  }
}
